import isElementInViewport from './isElementInViewport';
// need to check if the 'behavior' option is supported (because Safari...)
// if it is not, passing an options object into `scrollIntoView` can have problems
const IS_SCROLL_BEHAVIOUR_SUPPORTED = 'scrollBehavior' in window.document.documentElement.style;
// our options objects
const SCROLL_INTO_VIEW_OPTIONS_BASE = {
    behavior: 'smooth',
};
const SCROLL_INTO_VIEW_OPTIONS_START = Object.assign(Object.assign({}, SCROLL_INTO_VIEW_OPTIONS_BASE), { inline: 'nearest', block: 'start' });
const SCROLL_INTO_VIEW_OPTIONS_END = Object.assign(Object.assign({}, SCROLL_INTO_VIEW_OPTIONS_BASE), { inline: 'nearest', block: 'end' });
/**
 * get the argument to pass into scrollIntoView based on 'behavior' support
 */
const getScrollIntoViewArg = (startOrEnd = 'start') => {
    // use a boolean arg if 'behavior' is not supported
    // and default to true (top/start) as this is the default for scrollIntoView
    if (!IS_SCROLL_BEHAVIOUR_SUPPORTED) {
        return startOrEnd !== 'end';
    }
    // use the options object if 'behavior' is supported
    if (startOrEnd === 'end') {
        return SCROLL_INTO_VIEW_OPTIONS_END;
    }
    return SCROLL_INTO_VIEW_OPTIONS_START;
};
/**
 * smoothly scroll element into view (using native methods)
 */
const smoothlyScrollIntoView = (element) => {
    if (!element) {
        return;
    }
    // check if element is in the viewport so that we only scroll if needed;
    // note: we could use `.scrollIntoViewIfNeeded()` for this,
    // but that is still non-standard (and not currently supported in Firefox)
    const domRect = element.getBoundingClientRect();
    if (isElementInViewport(domRect)) {
        return;
    }
    // if the element is taller than the viewport,
    // or the top of the element is before the viewport start,
    // then scroll it to the top of the screen
    const isTallerThanViewport = domRect.height > window.innerHeight;
    const startOrEnd = isTallerThanViewport || domRect.top < 0 ? 'start' : 'end';
    const scrollIntoViewArg = getScrollIntoViewArg(startOrEnd);
    element.scrollIntoView(scrollIntoViewArg);
};
export default smoothlyScrollIntoView;
//# sourceMappingURL=smoothlyScrollIntoView.js.map